import { I18n } from 'src/translations/i18n';
import { toastr } from 'react-redux-toastr';
function showErrors(errors) {
    errors.forEach(({ Field, Message }) => {
        let errorTitle;
        const errorBody = Message || I18n.t('UnknownErrorTryLater');
        if (Field) {
            errorTitle = I18n.t('ErrorInProperty', { prop: Field });
        }
        else {
            errorTitle = I18n.t('Error');
        }
        toastr.error(errorTitle, errorBody);
    });
}
function showUnknownError(error) {
    if (!error.status) {
        toastr.error(I18n.t('ServerUnreachable'), '');
    }
    else {
        toastr.error(I18n.t('UnknownErrorTryLater'), `${I18n.t('ResponseStatus')}: ${error.status}`);
    }
}
function showWarnings(warnings) {
    warnings.forEach(({ Field, Message }) => {
        let errorTitle;
        const errorBody = Message || I18n.t('SomethingWentWrong');
        if (Field) {
            errorTitle = I18n.t('WarningAboutProperty', { prop: Field });
        }
        else {
            errorTitle = I18n.t('Warning');
        }
        toastr.warning(errorTitle, errorBody);
    });
}
export function toastrNetworkSuccess(response, successTitle = I18n.t('Success'), successMsg = '', successOpts) {
    const warnings = response.data.Warnings;
    if (warnings?.length) {
        toastr.warning(I18n.t('PartialSuccess'), '');
        console.warn('Warnings:', warnings);
        showWarnings(warnings);
    }
    else {
        toastr.success(successTitle, successMsg, successOpts);
    }
}
export function toastrNetworkWarnings(response) {
    const warnings = response.data.Warnings;
    if (warnings?.length) {
        console.warn('Warnings:', warnings);
        showWarnings(warnings);
    }
}
export function toastrNetworkError(error) {
    const errors = error.response?.data?.Errors;
    const warnings = error.response?.data?.Warnings;
    console.error('Network error:', error);
    if (!errors?.length && !warnings?.length) {
        showUnknownError(error);
    }
    else {
        if (errors?.length)
            showErrors(errors);
        if (warnings?.length)
            showWarnings(warnings);
    }
}
